import React, { useState,useEffect } from 'react';
import axios from 'api/axios';
import { Spinner } from 'react-bootstrap';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DefaultCard from 'components/mycomponents/DefaultCard';
import Flex from 'components/common/Flex';

const StudentStatistics = () => {
    // Declare State Variable
    const [data, setData] = useState(null);
    const [loadingData, setLoadingData] = useState(false);

    // Declare Constant Variable
    const DATA_URL = '/dashboard';
    const ACCESS_USER = JSON.parse(localStorage.getItem('accessUser'));
    const TOKEN_APP = ACCESS_USER ? ACCESS_USER.token : '';
    
    useEffect(() => {
        const getVehicleActivity = async () =>{
            setLoadingData(true);
            try {
                const response = await axios.get(`${DATA_URL}/student-statistic`, {
                    headers: {
                      'Authorization': `Bearer ${TOKEN_APP}`
                    }
                  });
                const responseResult = response?.data;
                const responseData = responseResult?.data;

                setData(responseData);

                setLoadingData(false);
                
            } catch (err) {
                setLoadingData(false);
                if (err.response) {
                    const response = err.response.data;
                    console.log(response.message);
                } else {
                    console.log('Something error with server. Please call administrator or developer.');
                }
            }
        }

        getVehicleActivity()
    }, [TOKEN_APP]);
    return (
        <DefaultCard>
            <DefaultCard.Header title={'Statistik Siswa'} />
            <DefaultCard.Body>
                {
                    loadingData ? (
                        <div className="align-center">
                            <Spinner animation="border  " className="me-2" />
                            <span className="fs-4">Loading ...</span>
                        </div>
                    ) : data ? data.map((val, idx) => {
                        return (
                            <Flex
                                key={idx}
                                alignItems="center"
                                justifyContent="between"
                                className={classNames('rounded-3 p-3 ', {
                                'mb-2': idx !== data.length
                                })}
                            >
                                <>
                                    <h6 className="mb-0">
                                    <FontAwesomeIcon
                                        icon="circle"
                                        className={`fs--1 me-3 ${val.color}`}
                                    />
                                        {val.vcdesc}
                                    </h6>
                                    <h6 className="text-600 mb-0">
                                        {val.total}
                                    </h6>
                                </>
                            </Flex>
                        )
                    }) : ''
                }
            </DefaultCard.Body>
        </DefaultCard>
    )
}

StudentStatistics.propTypes = {}

export default StudentStatistics;